import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#081428] text-[#EAEAEA]">
      <Navbar />
      <main className="container mx-auto px-8 md:px-32 lg:px-48 xl:px-64 pt-24 pb-12">
        <h1 className="text-4xl font-bold mb-8">Termos de Uso</h1>
        <h2 className="text-2xl font-semibold mb-6">Termos e Condições de Uso da LawX</h2>
        
        <p className="mb-8 text-gray-300">
          Ao acessar e utilizar os serviços da LawX, você concorda com os termos e condições estabelecidos abaixo. 
          Por favor, leia atentamente antes de utilizar nossa plataforma.
        </p>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">1. Aceitação dos Termos</h3>
          <p className="text-gray-300">
            Ao utilizar nossos serviços, você concorda expressamente com estes Termos de Uso. Se você não concordar 
            com algum dos termos aqui estabelecidos, não deverá utilizar nossos serviços.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">2. Descrição dos Serviços</h3>
          <p className="text-gray-300">
            A LawX oferece uma plataforma de inteligência artificial voltada para profissionais da área jurídica, 
            fornecendo ferramentas e recursos para otimizar o trabalho jurídico. Nossos serviços incluem, mas não 
            se limitam a, análise de documentos, pesquisa jurídica e automação de processos.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">3. Responsabilidades do Usuário</h3>
          <p className="text-gray-300">
            O usuário é responsável por manter a confidencialidade de sua conta e senha, bem como por todas as 
            atividades realizadas em sua conta. O usuário concorda em não usar os serviços para fins ilegais ou 
            não autorizados.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">4. Propriedade Intelectual</h3>
          <p className="text-gray-300">
            Todo o conteúdo disponível na plataforma LawX, incluindo mas não se limitando a textos, gráficos, 
            logos, ícones, imagens, clipes de áudio, downloads digitais e compilações de dados, é de propriedade 
            da LawX ou de seus fornecedores de conteúdo e está protegido pelas leis brasileiras e internacionais 
            de direitos autorais.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">5. Limitação de Responsabilidade</h3>
          <p className="text-gray-300">
            A LawX não se responsabiliza por quaisquer danos diretos, indiretos, incidentais, especiais ou 
            consequentes resultantes do uso ou da incapacidade de usar nossos serviços. O usuário entende e 
            concorda que utiliza a plataforma por sua conta e risco.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold mb-4">6. Modificações dos Termos</h3>
          <p className="text-gray-300">
            A LawX se reserva o direito de modificar estes termos a qualquer momento, sendo responsabilidade do 
            usuário verificar periodicamente as atualizações. O uso continuado dos serviços após a publicação de 
            quaisquer alterações constitui aceitação dessas alterações.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold mb-4">7. Contato</h3>
          <p className="text-gray-300">
            Para questões relacionadas a estes Termos de Uso, entre em contato conosco através do e-mail: contato@lawx.ai
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
